import { useEffect, useRef, useState } from "react";

const RecruitMessage = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="py-16 bg-[#F8FAF6] relative overflow-hidden"
      id="message"
      ref={sectionRef}
    >
      {/* Background decoration text */}
      <div
        className={`absolute top-12 right-0 text-[80px] sm:text-[180px] font-bold text-[#89B56B]/5 leading-none select-none pointer-events-none font-inter tracking-tight anim-bg-text ${
          isVisible ? "is-visible" : ""
        }`}
      >
        Message
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-16">

          {/* スマホ: 見出しを最上部に表示 / PC: 非表示（テキストブロック内に表示） */}
          <div
            className={`lg:hidden w-full anim-fade-right ${isVisible ? "is-visible" : ""}`}
          >
            <p className="text-[#89B56B] text-xs font-semibold tracking-[0.25em] uppercase mb-2 font-inter">
              Message
            </p>
            <h2 className="text-2xl font-bold text-[#89B56B] mb-0 leading-relaxed">
              人に必要とされる人を創る。
            </h2>
          </div>

          {/* Image */}
          <div
            className={`w-full lg:w-[45%] relative anim-fade-left ${
              isVisible ? "is-visible" : ""
            }`}
          >
            <div className="w-full h-[200px] sm:h-[320px] lg:h-[480px] rounded-lg overflow-hidden shadow-[0_8px_40px_rgba(0,0,0,0.08)]">
              <img
                src="/image/recruit-message1.jpeg"
                alt="代表メッセージ"
                title="代表メッセージ - 株式会社MSK"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Text */}
          <div
            className={`w-full lg:w-[55%] anim-fade-right ${
              isVisible ? "is-visible" : ""
            }`}
            style={{ transitionDelay: "0.2s" }}
          >
            {/* PC版のみ見出しを表示 */}
            <div className="hidden lg:block">
              <p className="text-[#89B56B] text-xs font-semibold tracking-[0.25em] uppercase mb-4 font-inter">
                Message
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#89B56B] mb-8 leading-relaxed">
                人に必要とされる人を創る。
              </h2>
            </div>
            <div className="space-y-5 text-sm text-gray-600 leading-[2] mt-3 lg:mt-0">
              <p>
                私たちが大事にしている理念が、この「人に必要とされる人を創る」こと。人を育て、社会から必要とされる会社を目指しています。それが社会貢献になると同時に、私たちの存在意義となる。これこそが社会を豊かにすると確信しています。
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default RecruitMessage;
